import {Injectable} from '@angular/core';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ConfirmDialogComponent} from "../../_components/_widgets/confirm-dialog/confirm-dialog.component";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {

  public loading$ = new BehaviorSubject<boolean>(false);
  private dialogRef: MatDialogRef<ConfirmDialogComponent> | null = null;

  constructor(private dialog: MatDialog) {
  }

  open(message: string, value?: string, observable?: Observable<any>): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      if (this.dialogRef) {
        this.dialogRef.close();
      }

      this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: false,
      });
      this.dialogRef.componentInstance.message = message;
      this.dialogRef.componentInstance.value = value;
      this.dialogRef.componentInstance.loading$ = this.loading$;
      this.dialogRef.componentInstance.hasObservable = observable != null;
      this.dialogRef.componentInstance.closeRequest.subscribe((result) => {
        if (result && observable) {
          this.loading$.next(true);
          observable.subscribe(x => {
            this.loading$.next(false);
            if (this.dialogRef) {
              this.dialogRef.close(result);
            }
          });
        }
      });

      this.dialogRef.afterClosed().subscribe(result => {
        resolve(result);
        this.dialogRef = null;
      });
    });
  }

}
